module.exports = __webpack_public_path__ + "img/cargocar.639fb7ba.png";